/**
 * Split Date
 * @description : 
 */

import * as moment from 'moment';

export default function setUpSplitDate(rootEl) {

    const hiddenInputEl = rootEl.querySelector('.js-split-date__hidden-input');

    const dayInputEl = rootEl.querySelector('.js-split-date__day-input');
    const monthInputEl = rootEl.querySelector('.js-split-date__month-input');
    const yearInputEl = rootEl.querySelector('.js-split-date__year-input');

    const validateEnteredDate = () => {
        const dayValue = dayInputEl.value;
        const monthValue = monthInputEl.value;
        const yearValue = yearInputEl.value;

        if (!dayValue && !monthValue && !yearValue) {
            return {
                dateString: '',
                isValid: false
            };
        }
        console.log(dayValue);

        if ((dayValue == 0 || dayValue > 31) ||
            (monthValue == 0 || monthValue > 12) ||
            (yearValue < 1800 || yearValue > 9999)) {
            return {
                dateString: '',
                isValid: false
            };
        }

        const dayString = dayValue ? dayValue.padStart(2, '0') : '__';
        const monthString = monthValue ? monthValue.padStart(2, '0') : '__';
        const yearString = yearValue ? yearValue.padStart(4, '0') : '____';

        const dateString = `${yearString}-${monthString}-${dayString}`;

        

        if (!dateString.match(/^([0-9]{4}-[0-9]{2}-[0-9]{2})?$/)) {
            return {
                dateString: `${dateString}`,
                isValid: false
            };
        }

        const momentDate = moment(dateString, 'YYYY-MM-DD');
        if (momentDate.isValid()) {
            return {
                dateString: momentDate.format('YYYY-MM-DD'),
                isValid: true
            };
        } else {
            return {
                dateString: `${dateString} *`, // Adding a star here so it fails the Umbraco Forms regex we added.
                isValid: false
            };
        }
    };

    const setHiddenInputValue = (value) => {
        hiddenInputEl.value = value;
        hiddenInputEl.dispatchEvent(new Event('input'));
    };

    const updateHiddenInput = () => {
        const validityInfo = validateEnteredDate();
        if (validityInfo.isValid) {
            setHiddenInputValue(validityInfo.dateString);
        }
    };

    let blurTimeout;
    [dayInputEl, monthInputEl, yearInputEl].forEach(inputEl => {
        inputEl.addEventListener('input', updateHiddenInput);
        inputEl.addEventListener('focus', () => clearTimeout(blurTimeout));
        inputEl.addEventListener('blur', () => {
            blurTimeout = setTimeout(() => {
                const validityInfo = validateEnteredDate();
                setHiddenInputValue(validityInfo.dateString);
            }, 100);
        });
    });

    updateHiddenInput();


    /* Watch for Umbraco Forms validation errors on the hidden input and note them on the field element. */

    const mo = new MutationObserver((entries) => {
        const record = entries[0];
        if (record.attributeName === 'class') {
            rootEl.classList.toggle('has-error', hiddenInputEl.classList.contains('input-validation-error'));
        }
    });
    mo.observe(hiddenInputEl, {
        attributes: true
    });

};